import React from 'react';

export const useSystemViewDialogs = () => {
  const [showCreateDialog, setShowCreateDialog] = React.useState<boolean>(false);
  const [showRenameDialog, setShowRenameDialog] = React.useState<boolean>(false);

  const handleCreateSystemView = () => setShowCreateDialog(true);
  const handleDialogClose = () => setShowCreateDialog(false);
  const handleRenameView = () => setShowRenameDialog(true);
  const handleRenameDialogClose = () => setShowRenameDialog(false);

  return {
    showCreateDialog,
    showRenameDialog,
    handleCreateSystemView,
    handleDialogClose,
    handleRenameView,
    handleRenameDialogClose
  };
};
